/* Guides pillar: moves each card's list under the row, opens one list at a time (Read more / Close, or the
   photograph), opens the list a find-in-page or a link lands in (#faq, #gdp-size, ?gx=mat), and drives the
   phone slider's progress line. The lists are in the HTML from the server; nothing is fetched. */
(function () {
  if (window.__guidesPillar) return;
  window.__guidesPillar = true;
  function ev(name, p) { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, p || {})); }

  function init(root) {
    (root || document).querySelectorAll('[data-gdp]').forEach(function (sec) {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      var dock = sec.querySelector('[data-gdp-panels]'), track = sec.querySelector('[data-gdp-track]');
      var toggles = [].slice.call(sec.querySelectorAll('[data-gdp-toggle]'));
      var panels = toggles.map(function (b) { return document.getElementById(b.getAttribute('aria-controls')); });
      panels.forEach(function (p) { if (p && dock) dock.appendChild(p); });

      function set(i, open) {
        var b = toggles[i], p = panels[i];
        if (!b || !p) return;
        if (open) p.removeAttribute('hidden'); else p.setAttribute('hidden', 'until-found');
        b.setAttribute('aria-expanded', String(open));
        var l = b.querySelector('[data-gdp-label]');
        if (l) l.textContent = b.getAttribute(open ? 'data-close' : 'data-open');
      }
      function only(i) { toggles.forEach(function (b, k) { set(k, k === i); }); }
      toggles.forEach(function (b, i) {
        b.addEventListener('click', function () {
          var open = b.getAttribute('aria-expanded') !== 'true';
          if (open) { only(i); ev('guides_expand', { group: panels[i] && panels[i].getAttribute('data-gdp-panel') }); }
          else set(i, false);
        });
        var pic = b.closest('[data-gdp-card]') && b.closest('[data-gdp-card]').querySelector('[data-gdp-pic]');
        if (pic) pic.addEventListener('click', function () { b.click(); });
        if (panels[i]) panels[i].addEventListener('beforematch', function () { only(i); });
      });

      /* A link straight to a list: #faq, #gdp-size, or ?gx=size as the 2026 library took it */
      var gx = new URLSearchParams(location.search).get('gx'), hash = location.hash.slice(1);
      panels.forEach(function (p, i) {
        if (p && (p.id === hash || p.getAttribute('data-gdp-panel') === gx)) only(i);
      });

      /* Phones: progress line and "1 / 3" */
      var fill = sec.querySelector('[data-gdp-fill]'), n = sec.querySelector('[data-gdp-n]');
      var cards = track ? track.children : [];
      if (track && fill && n && cards.length) {
        fill.style.width = (100 / cards.length) + '%';
        var upd = function () {
          var w = cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
          var k = Math.min(cards.length - 1, Math.max(0, Math.round(track.scrollLeft / w)));
          fill.style.left = (k * 100 / cards.length) + '%';
          n.textContent = (k + 1) + ' / ' + cards.length;
        };
        track.addEventListener('scroll', upd, { passive: true });
        upd();
      }
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
